var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecorYellowDott(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 69,
    viewBox: "0 0 76 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_12499)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.2402,
    cy: 62.2402,
    r: 61.7402,
    transform: "matrix(1 0 0 -1 -48 65.4805)",
    stroke: "#F3C948",
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52.9805,
    rx: 17,
    ry: 16.5,
    fill: "url(#paint0_linear_1910_12499)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1910_12499",
    x1: 52,
    y1: 36.4805,
    x2: 52,
    y2: 69.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_12499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecorYellowDott);
export default __webpack_public_path__ + "static/media/decor-yellow-dott.454e4f396efe36f96ca6a497a573cbd8.svg";
export { ForwardRef as ReactComponent };